export default __webpack_public_path__ + "static/media/ab-icon.0b9b979b.svg";